import { gql } from '@apollo/client'
import { reviewFragment } from 'modules/reviews/fragments.graphql'

export const reviewsQuery = gql`
  ${reviewFragment}
  query Reviews($take: Int, $brandIds: [ID!], $withMedia: Boolean, $minimumScore: Int) {
    reviews(take: $take, brandIds: $brandIds, withMedia: $withMedia, minimumScore: $minimumScore) {
      ...ReviewFields
      brand {
        id
        slug
        title
        primaryImageFullPath
      }
    }
  }
`
